module.exports = __webpack_public_path__ + "img/loan.0d4f076c.png";